module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOC44ODg4OUg3LjExMTExVjBIMFY4Ljg4ODg5Wk0wIDE2SDcuMTExMTFWMTAuNjY2N0gwVjE2Wk04Ljg4ODg5IDE2SDE2VjcuMTExMTFIOC44ODg4OVYxNlpNOC44ODg4OSAwVjUuMzMzMzNIMTZWMEg4Ljg4ODg5WiIgZmlsbD0iI0U0RUNGMyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard.svg
// module id = sm9Y
// module chunks = 22